import React from 'react';
import _ from 'lodash';
import { Select } from 'antd/lib/index';
import styled from 'styled-components';
import classNames from 'classnames';

import { closingRanges } from '../../constants/compound';
import DecomposedMillisPicker from './DecomposedMillisPicker';

const { Option } = Select;

const customClosingRange = closingRanges.find((cr) => cr.custom);

const StyledClosingRangePicker = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 10px;

  .left-side-container {
    display: flex;
    align-items: center;
  }

  .select-label {
    white-space: nowrap;
    margin-right: 10px;
  }
`;

const StyledSelect = styled(Select)`
  width: auto;
  min-width: 100px;
`;

const ClosingRangePicker = ({
  selectClassName,
  inputClassName,
  closingRange,
  onChange,
  global,
}) => {
  let closingRangeVar = closingRange;

  closingRangeVar = closingRanges.find(
    (cr) => cr.value === closingRangeVar.value && cr.custom === closingRangeVar.custom
  );

  closingRangeVar = closingRangeVar || customClosingRange;

  return (
    <StyledClosingRangePicker>
      <div className="left-side-container">
        <div className={classNames('disable-select', 'select-label')}>Closing range:</div>
        <StyledSelect
          dropdownMatchSelectWidth={false}
          dropdownStyle={{ width: 'auto' }}
          value={closingRangeVar.key}
          onSelect={(key) =>
            onChange(
              _.pick(
                closingRanges.find((cr) => cr.key === key),
                ['value', 'custom']
              )
            )
          }
          className={selectClassName}
          getPopupContainer={(triggerNode) => triggerNode}
          virtual={false}
        >
          {closingRanges
            .filter((cr) => (global ? !!cr.global : !cr.global))
            .map((cr) => (
              <Option key={cr.key} value={cr.key}>
                {cr.text}
              </Option>
            ))}
        </StyledSelect>
      </div>
      {closingRangeVar.custom ? (
        <DecomposedMillisPicker
          value={closingRange.value}
          onChange={(v) => onChange({ custom: true, value: v })}
          style={{ marginLeft: 15 }}
          inputClassName={inputClassName}
        />
      ) : null}
    </StyledClosingRangePicker>
  );
};

export default ClosingRangePicker;
